module.exports = __webpack_public_path__ + "static/img/newRetailTop.05b62ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newRetailTop.png
// module id = FWgh
// module chunks = 2